(function () {
  'use strict';

  if (window.GroupedBundleProduct) return;

  // _bundle_labels 를 잇는 구분자. 카트 템플릿이 이 문자열로 다시 쪼갠다
  // (snippets/cart-items.liquid) — 한쪽만 바꾸면 표시가 깨진다.
  var LABEL_SEPARATOR = ' / ';

  // 라벨 안에 구분자와 같은 문자열이 들어가면 카트 표시가 한 줄씩 밀린다. 상품명은
  // 운영자가 바꾸는 값이므로 여기서 막는다(구분자를 바꾸려면 카트 템플릿도 함께).
  function sanitizeLabel(value) {
    return String(value == null ? '' : value).split(LABEL_SEPARATOR).join(' ');
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function init(sectionEl) {
    if (sectionEl.dataset.groupedBundleInitialized) return;
    sectionEl.dataset.groupedBundleInitialized = 'true';
    initMediaThumbs(sectionEl);

    var sectionId = sectionEl.getAttribute('data-section-id');
    var dataEl = document.getElementById('GroupedBundleData-' + sectionId);
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('[GroupedBundleProduct] GroupedBundleData JSON parse error', e);
      return;
    }

    if (!configurationMatches(data)) {
      $('[data-grouped-bundle-controls]', sectionEl).hidden = true;
      $('[data-setup-error]', sectionEl).hidden = false;
      return;
    }
    var slotState = {};
    var slotEls = $$('[data-grouped-bundle-slot]', sectionEl);
    var totalSlots = slotEls.length;

    var accordion = createAccordion(slotEls);

    slotEls.forEach(function (slotEl) {
      var catalog = data.groups[Number(slotEl.getAttribute('data-group-index'))].products;
      initSlot(slotEl, catalog, slotState, accordion, data.groups.length === 1, function (changedEl, becameComplete) {
        updateProgress(sectionEl, slotState, totalSlots);
        if (becameComplete) advanceAccordion(slotEls, slotState, accordion, changedEl);
      });
    });

    // 첫 슬롯만 열고 시작. 마크업 기본값이 '열림'이라 이 호출이 나머지를 닫는다.
    if (slotEls.length) accordion.open(slotEls[0]);

    updateProgress(sectionEl, slotState, totalSlots);

    var addBtn = $('#GroupedBundleAddToCart-' + sectionId, sectionEl);
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        submitToCart(sectionEl, data, slotState, totalSlots, slotEls);
      });
    }
  }

  // 아코디언 — 한 번에 하나의 슬롯만 열어둔다. 열림 상태는 slot의
  // data-slot-open 속성 하나로만 표현하고 표시는 전부 CSS가 담당한다.
  // 기본 마크업에서 열린 칸들을 초기화 시 닫는다.
  function createAccordion(slotEls) {
    function setOpen(slotEl, open) {
      slotEl.setAttribute('data-slot-open', open ? 'true' : 'false');
      var toggle = $('[data-slot-toggle]', slotEl);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    return {
      open: function (target) {
        slotEls.forEach(function (el) { setOpen(el, el === target); });
      },
      closeAll: function () {
        slotEls.forEach(function (el) { setOpen(el, false); });
      },
      toggle: function (slotEl) {
        if (slotEl.getAttribute('data-slot-open') === 'false') this.open(slotEl);
        else setOpen(slotEl, false);
      }
    };
  }

  // 단일 그룹은 도수 안내·입력으로, 여러 그룹은 기존 슬롯 제목으로 이동한다.
  function scrollToSlot(slotEl, singleGroup, behavior) {
    var control = $(singleGroup ? '[data-power-select]' : '[data-slot-toggle]', slotEl);
    var target = singleGroup ? control.closest('.GroupedBundle__SlotField') : control;
    var header = $('.Header__Wrapper');
    target.style.scrollMarginTop = ((header ? header.getBoundingClientRect().bottom : 0) + 16) + 'px';
    control.focus({ preventScroll: true });
    target.scrollIntoView({
      behavior: behavior || (window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'),
      block: 'start',
      inline: 'nearest'
    });
  }

  // 다음 미완성 슬롯을 열고, 전부 완성되면 접힌 마지막 요약과 담기 버튼으로 즉시 이동한다.
  function advanceAccordion(slotEls, slotState, accordion, changedEl) {
    var next = null;
    for (var i = 0; i < slotEls.length; i++) {
      if (slotEls[i] === changedEl) continue;
      var id = slotEls[i].getAttribute('data-slot-id');
      if (!(slotState[id] && slotState[id].variantId)) { next = slotEls[i]; break; }
    }
    if (next) {
      accordion.open(next);
    } else {
      accordion.closeAll();
      scrollToSlot(slotEls[slotEls.length - 1], false, 'instant');
    }
  }

  function initMediaThumbs(sectionEl) {
    var main = $('.GroupedBundle__Image', sectionEl);
    var thumbs = $$('.GroupedBundle__MediaThumb', sectionEl);
    var strip = $('.GroupedBundle__MediaThumbs', sectionEl);
    var drag = null;
    var dragged = false;
    if (strip) {
      strip.addEventListener('dragstart', function (event) { event.preventDefault(); });
      strip.addEventListener('pointerdown', function (event) {
        dragged = false;
        if (event.pointerType !== 'mouse' || event.button !== 0 || strip.scrollWidth <= strip.clientWidth) return;
        drag = { pointerId: event.pointerId, x: event.clientX, left: strip.scrollLeft };
      });
      strip.addEventListener('pointermove', function (event) {
        if (!drag || event.pointerId !== drag.pointerId) return;
        var offset = event.clientX - drag.x;
        if (!dragged && Math.abs(offset) < 5) return;
        if (!dragged) {
          dragged = true;
          strip.setPointerCapture(event.pointerId);
          strip.classList.add('is-dragging');
        }
        event.preventDefault();
        strip.scrollLeft = drag.left - offset;
      });
      function endDrag() {
        drag = null;
        strip.classList.remove('is-dragging');
      }
      strip.addEventListener('pointerup', endDrag);
      strip.addEventListener('pointercancel', endDrag);
      strip.addEventListener('lostpointercapture', endDrag);
      strip.addEventListener('pointerleave', function () { if (!dragged) endDrag(); });
      strip.addEventListener('click', function (event) {
        if (!dragged || event.detail === 0) return;
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
      }, true);
    }
    thumbs.forEach(function (button) {
      button.addEventListener('click', function () {
        main.src = button.getAttribute('data-image-src');
        main.removeAttribute('srcset');
        main.alt = button.getAttribute('data-image-alt');
        main.width = Number(button.getAttribute('data-image-width'));
        main.height = Number(button.getAttribute('data-image-height'));
        thumbs.forEach(function (thumb) { thumb.setAttribute('aria-pressed', String(thumb === button)); });
        var strip = button.parentElement;
        var bounds = strip.getBoundingClientRect();
        var selected = button.getBoundingClientRect();
        var offset = selected.left < bounds.left ? selected.left - bounds.left : Math.max(0, selected.right - bounds.right);
        if (offset) strip.scrollBy({
          left: offset,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      });
    });
  }

  // 상품(색상) 전체가 품절인지 — 하나라도 available variant가 있으면 재고 있음.
  function colorHasStock(entry) {
    return (entry.variants || []).some(function (v) { return v.available; });
  }

  function findCatalogEntry(catalog, productId) {
    for (var i = 0; i < catalog.length; i++) {
      if (String(catalog[i].productId) === String(productId)) return catalog[i];
    }
    return null;
  }

  function initSlot(slotEl, catalog, slotState, accordion, singleGroup, onChange) {
    var slotId = slotEl.getAttribute('data-slot-id');
    var colorGroupEl = $('[data-color-group]', slotEl);
    var powerSelectEl = $('[data-power-select]', slotEl);
    var statusEl = $('[data-slot-status]', slotEl);
    var toggleEl = $('[data-slot-toggle]', slotEl);

    slotState[slotId] = { variantId: null, productId: null, power: null };
    if (!catalog.some(colorHasStock)) {
      slotEl.setAttribute('data-slot-unavailable', '');
      statusEl.textContent = statusEl.getAttribute('data-status-unavailable');
    }

    if (toggleEl) {
      toggleEl.addEventListener('click', function () {
        accordion.toggle(slotEl);
      });
    }

    populateColorGroup(colorGroupEl, catalog, function (productId) {
      var entry = findCatalogEntry(catalog, productId);
      slotState[slotId].productId = productId;
      slotState[slotId].variantId = null;
      slotState[slotId].power = null;
      populatePowerSelect(powerSelectEl, entry ? entry.variants : []);
      powerSelectEl.disabled = !entry;
      updateSlotStatus(slotEl, statusEl, slotState[slotId], catalog);
      // 색상만 고른 단계 — 도수가 남았으니 슬롯을 넘기지 않는다.
      onChange(slotEl, false);
      scrollToSlot(slotEl, singleGroup);
    });

    powerSelectEl.addEventListener('change', function () {
      var wasComplete = !!slotState[slotId].variantId;
      var variantId = powerSelectEl.value;
      if (!variantId) {
        slotState[slotId].variantId = null;
        slotState[slotId].power = null;
      } else {
        slotState[slotId].variantId = variantId;
        var selectedOpt = powerSelectEl.options[powerSelectEl.selectedIndex];
        slotState[slotId].power = selectedOpt.getAttribute('data-power');
      }
      updateSlotStatus(slotEl, statusEl, slotState[slotId], catalog);
      // 이미 완성된 슬롯의 도수만 바꾼 경우엔 자동 이동하지 않는다(사용자가
      // 그 슬롯을 다시 열어 수정하는 중이므로 화면을 빼앗으면 안 된다).
      onChange(slotEl, !wasComplete && !!slotState[slotId].variantId);
    });
  }

  // 같은 그룹의 칸들만 상품 목록을 공유한다.
  function populateColorGroup(groupEl, catalog, onSelect) {
    var unavailableSuffix = groupEl.getAttribute('data-unavailable-suffix') || '';
    groupEl.innerHTML = '';

    catalog.forEach(function (entry) {
      var hasStock = colorHasStock(entry);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'GroupedBundle__ColorSwatch';
      btn.setAttribute('aria-pressed', 'false');
      btn.disabled = !hasStock;

      // 라벨 텍스트가 접근가능한 이름을 제공하므로 이미지는 장식으로 처리(alt='').
      if (entry.image) {
        var img = document.createElement('img');
        img.src = entry.image;
        img.alt = '';
        img.loading = 'lazy';
        btn.appendChild(img);
      }

      // 상품명은 Liquid가 내보낸 product.title 원문을 그대로 쓴다 — 코드에서
      // 자르거나 조합하지 않는다(품절 표기 접미사만 뒤에 붙는다).
      var labelSpan = document.createElement('span');
      labelSpan.className = 'GroupedBundle__ColorSwatchLabel';
      labelSpan.textContent = (entry.label || '') + (hasStock ? '' : unavailableSuffix);
      btn.appendChild(labelSpan);

      btn.addEventListener('click', function () {
        $$('.GroupedBundle__ColorSwatch', groupEl).forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        btn.setAttribute('aria-pressed', 'true');
        onSelect(entry.productId);
      });

      groupEl.appendChild(btn);
    });
  }

  function populatePowerSelect(selectEl, variants) {
    var placeholderText = selectEl.getAttribute('data-placeholder') || '';
    var unavailableSuffix = selectEl.getAttribute('data-unavailable-suffix') || '';

    while (selectEl.options.length) selectEl.remove(0);
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = placeholderText;
    selectEl.appendChild(placeholder);

    (variants || []).forEach(function (v) {
      var opt = document.createElement('option');
      opt.value = String(v.id);
      opt.setAttribute('data-power', v.power || '');
      opt.textContent = (v.power || '') + (v.available ? '' : unavailableSuffix);
      if (!v.available) opt.disabled = true;
      selectEl.appendChild(opt);
    });
  }

  function updateSlotStatus(slotEl, statusEl, state, catalog) {
    var emptyText = statusEl.getAttribute('data-status-empty') || '';
    var completeText = statusEl.getAttribute('data-status-complete') || '';
    var thumbEl = $('[data-summary-thumb]', slotEl);
    var textEl = $('[data-summary-text]', slotEl);

    if (state.variantId) {
      slotEl.setAttribute('data-slot-complete', 'true');
      statusEl.textContent = completeText;

      var entry = findCatalogEntry(catalog, state.productId);
      var label = (entry && entry.label) || '';
      if (thumbEl) {
        if (entry && entry.image) {
          thumbEl.src = entry.image;
          thumbEl.hidden = false;
        } else {
          thumbEl.removeAttribute('src');
          thumbEl.hidden = true;
        }
      }
      if (textEl) textEl.textContent = state.power ? (label + ' / ' + state.power) : label;
    } else {
      slotEl.removeAttribute('data-slot-complete');
      statusEl.textContent = emptyText;
      if (thumbEl) {
        thumbEl.removeAttribute('src');
        thumbEl.hidden = true;
      }
      if (textEl) textEl.textContent = '';
    }
  }

  function updateProgress(sectionEl, slotState, totalSlots) {
    var sectionId = sectionEl.getAttribute('data-section-id');
    var selected = Object.keys(slotState).filter(function (k) {
      return slotState[k].variantId;
    }).length;
    var remaining = totalSlots - selected;

    var progressEl = $('#GroupedBundleProgress-' + sectionId, sectionEl);
    var addBtn = $('#GroupedBundleAddToCart-' + sectionId, sectionEl);

    // 남은 개수 안내는 미완료일 때만 띄운다. 전부 고르면 문단 자체를 숨긴다 —
    // 완료 사실은 담기 버튼이 활성화되는 것으로 충분히 전달된다(2026-08-18 피드백:
    // 완료 문구가 버튼처럼 보여 오해를 샀다).
    if (progressEl) {
      if (remaining === 0) {
        progressEl.classList.add('hidden');
        progressEl.textContent = '';
      } else {
        var tmpl = progressEl.getAttribute('data-progress-template') || '';
        progressEl.textContent = tmpl.replace('__N__', String(remaining));
        progressEl.classList.remove('hidden');
      }
    }
    var unavailable = false;
    $$('[data-grouped-bundle-group]', sectionEl).forEach(function (groupEl) {
      var groupSlots = $$('[data-grouped-bundle-slot]', groupEl);
      var completed = groupSlots.filter(function (slotEl) {
        return slotState[slotEl.getAttribute('data-slot-id')].variantId;
      }).length;
      $('[data-group-progress]', groupEl).textContent = completed + ' / ' + groupSlots.length;
      if (!groupEl.querySelector('.GroupedBundle__ColorSwatch:not(:disabled)')) unavailable = true;
    });
    if (unavailable && progressEl) {
      progressEl.classList.remove('hidden');
      progressEl.textContent = progressEl.getAttribute('data-progress-unavailable');
    }
    if (addBtn) addBtn.disabled = unavailable || remaining !== 0 || sectionEl.dataset.groupedBundleSubmitting === 'true';
  }

  // 고정 구성품과 화면의 그룹·상품·도수가 동기화 규칙과 일치할 때만 선택 UI를 활성화한다.
  function configurationMatches(data) {
    var rules = data.rules;
    if (!rules || (rules.version !== 3 && rules.version !== 4) || !rules.synced_at || !Array.isArray(rules.groups) ||
        !Array.isArray(data.groups) || !data.groups.length || data.groups.length !== rules.groups.length) return false;
    var fixedItems = data.fixedItems || [];
    var fixedRules = rules.fixed_items || [];
    if (!Array.isArray(fixedItems) || !Array.isArray(fixedRules) || fixedItems.length !== fixedRules.length ||
        !fixedItems.every(function (item, index) {
          var rule = fixedRules[index];
          return rule && String(item.productId) === rule.product_id && (rules.version === 4 ||
            (Array.isArray(rule.variant_ids) && rule.variant_ids.indexOf(String(item.variantId)) !== -1));
        })) return false;
    var total = fixedItems.length;
    return data.groups.every(function (group, index) {
      var rule = rules.groups[index];
      if (!rule || group.id !== rule.id || !Number.isInteger(group.slotCount) || group.slotCount < 1 ||
          group.slotCount > 50 || group.slotCount !== rule.slot_count || !group.products.length) return false;
      total += group.slotCount;
      var productIds = group.products.map(function (product) { return String(product.productId); });
      var variantIds = [].concat.apply([], group.products.map(function (product) {
        return product.variants.map(function (variant) { return String(variant.id); });
      }));
      return total <= 150 && JSON.stringify(productIds) === JSON.stringify(rule.product_ids) &&
        (rules.version === 4 || (Array.isArray(rule.variant_ids) &&
        JSON.stringify(variantIds.slice().sort()) === JSON.stringify(rule.variant_ids.slice().sort())));
    });
  }

  // 언어별 경로에서도 해당 스토어의 카트 URL을 사용한다.
  function cartUrl(path) {
    return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + path;
  }

  // Shopify의 오류 응답을 호출한 곳으로 전달한다.
  async function cartRequest(path, body) {
    var response = await fetch(cartUrl(path), {
      method: body ? 'POST' : 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    var result = await response.json();
    if (!response.ok) throw result;
    return result;
  }

  // 같은 variant여도 선택 구성이 다른 카트 행은 구분한다.
  function matchesItem(line, item) {
    if (String(line.variant_id || line.id) !== String(item.id)) return false;
    var properties = line.properties || {};
    var keys = Object.keys(item.properties);
    return Object.keys(properties).length === keys.length && keys.every(function (key) {
      return properties[key] === item.properties[key];
    });
  }

  // 이번에 추가한 행만 검사하고 확장 실패 시 기존 수량을 복원한다.
  async function submitToCart(sectionEl, data, slotState, totalSlots, slotEls) {
    if (sectionEl.dataset.groupedBundleSubmitting === 'true') return;
    var sectionId = sectionEl.getAttribute('data-section-id');
    var addBtn = $('#GroupedBundleAddToCart-' + sectionId, sectionEl);
    var errorEl = $('#GroupedBundleError-' + sectionId, sectionEl);
    var labelEl = addBtn.querySelector('.Button__Label');
    var controls = $('[data-grouped-bundle-controls]', sectionEl);
    var valid = slotEls.every(function (slotEl) {
      var state = slotState[slotEl.getAttribute('data-slot-id')];
      var group = data.groups[Number(slotEl.getAttribute('data-group-index'))];
      var product = findCatalogEntry(group.products, state.productId);
      return product && product.variants.some(function (variant) {
        return String(variant.id) === String(state.variantId) && variant.available;
      });
    });
    if (!valid || slotEls.length !== totalSlots) {
      showError(errorEl, addBtn.getAttribute('data-error-incomplete'));
      return;
    }

    hideError(errorEl);
    sectionEl.dataset.groupedBundleSubmitting = 'true';
    controls.inert = true;
    addBtn.disabled = true;
    labelEl.textContent = addBtn.getAttribute('data-label-adding');
    try {
      var item = buildCartItem(data, slotState, slotEls);
      // 이전 HTML 캐시에만 서버 발급을 유지하고 새 화면은 미리 생성한 서명을 사용한다.
      if (data.rules.version === 4 && !item.properties._bundle_proof) {
        var authorization = await cartRequest('apps/grouped-bundle/authorize', {
          parentVariantId: String(item.id), variantIds: item.properties._bundle_items.split(',')
        });
        if (typeof authorization.proof !== 'string' || !authorization.proof) throw new Error('bundle-expand-failed');
        item.properties._bundle_proof = authorization.proof;
      }
      var added = await cartRequest('cart/add.js', {
        items: [item], sections: ['mini-cart'], sections_url: cartUrl('cart')
      });
      var addedLine = added.items[0];
      // add 응답의 수량은 같은 구성으로 이미 담긴 수량을 포함한 합계다.
      var previousQuantity = addedLine.quantity - item.quantity;
      var line;
      try {
        var after = await cartRequest('cart.js');
        line = after.items.find(function (entry) { return entry.key === addedLine.key && matchesItem(entry, item); }) ||
          after.items.find(function (entry) { return matchesItem(entry, item); });
        if (!line || !line.has_components) throw new Error('bundle-expand-failed');
      } catch (error) {
        await cartRequest('cart/change.js', { id: (line || addedLine).key, quantity: previousQuantity });
        throw new Error('bundle-expand-failed');
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true, detail: { sections: added.sections }
      }));
      document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
      labelEl.textContent = addBtn.getAttribute('data-label-added');
    } catch (error) {
      var message = error.message === 'bundle-expand-failed' ? addBtn.getAttribute('data-error-expand') :
        (error.status === 422 ? addBtn.getAttribute('data-error-unavailable') : addBtn.getAttribute('data-error-cart-add'));
      showError(errorEl, message);
      labelEl.textContent = addBtn.getAttribute('data-label-default');
    } finally {
      controls.inert = false;
      sectionEl.dataset.groupedBundleSubmitting = 'false';
      updateProgress(sectionEl, slotState, totalSlots);
    }
  }

  // 고정 구성품을 먼저 담고 그룹과 칸 순서를 보존해 선택 결과를 연결한다.
  function buildCartItem(data, slotState, slotEls) {
    var ids = (data.fixedItems || []).map(function (item) { return String(item.variantId); });
    var labels = (data.fixedItems || []).map(function (item) { return sanitizeLabel(item.title); });
    var products = (data.fixedItems || []).map(function (item) { return String(item.productId); });
    var proofs = (data.fixedItems || []).map(function (item) { return item.proof; });
    slotEls.forEach(function (slotEl) {
      var state = slotState[slotEl.getAttribute('data-slot-id')];
      var catalog = data.groups[Number(slotEl.getAttribute('data-group-index'))].products;
      var product = findCatalogEntry(catalog, state.productId);
      ids.push(String(state.variantId));
      products.push(String(product.productId));
      proofs.push(product.variants.find(function (variant) { return String(variant.id) === String(state.variantId); }).proof);
      labels.push(sanitizeLabel(product.label + (state.power ? ' (' + state.power + ')' : '')));
    });
    var item = {
      id: data.bundleMain.variantId,
      quantity: 1,
      properties: {
        _bundle_items: ids.join(','),
        _bundle_labels: labels.join(LABEL_SEPARATOR),
        _bundle_v: String(data.rules.version)
      }
    };
    if (data.rules.version === 4 && data.proofMode === 'component-v1') {
      if (!proofs.every(function (proof) { return typeof proof === 'string' && /^[0-9a-f]{64}$/.test(proof); })) {
        throw new Error('bundle-expand-failed');
      }
      item.properties._bundle_proof = 'p1.' + products.join(',') + '.' + proofs.join(',');
    }
    return item;
  }

  function showError(el, msg) {
    if (!el) return;
    el.textContent = msg;
    el.classList.remove('hidden');
  }
  function hideError(el) {
    if (!el) return;
    el.textContent = '';
    el.classList.add('hidden');
  }

  function initAll() {
    $$('[data-section-type="grouped-bundle-product"]').forEach(init);
  }

  window.GroupedBundleProduct = { init: init, initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify section reload (Customize editor)
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.matches('[data-section-type="grouped-bundle-product"]') ? e.target : e.target.querySelector('[data-section-type="grouped-bundle-product"]');
    if (section) init(section);
  });
})();
